import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import InputField from "../ui/InputField";
import SelectField from "../ui/SelectField";
import { toast } from "react-toastify";

const TIPOS = [
  { _id: "text", name: "Texto" },
  { _id: "number", name: "Numérico" },
  { _id: "select", name: "Selección" },
  { _id: "boolean", name: "Sí / No" },
  { _id: "date", name: "Fecha" },
];

const CaracteristicaForm = ({ grupo, data, onClose, onSaved }) => {
  const [form, setForm] = useState({
    nombre: "",
    key: "",
    tipo: "text",
    opciones: [],
    requerido: false,
    filtrable: false,
  });

  const [nuevaOpcion, setNuevaOpcion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [busqueda, setBusqueda] = useState("");

  /* ---------------- CARGA EDICIÓN ---------------- */
  useEffect(() => {
    if (data) {
      setForm({
        nombre: data.nombre,
        key: data.key,
        tipo: data.tipo,
        opciones: data.opciones || [],
        requerido: data.requerido || false,
        filtrable: data.filtrable || false,
      });
    }
  }, [data]);

  /* ---------------- HANDLERS ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const addOpcion = () => {
    if (!nuevaOpcion.trim()) return;

    setForm((p) => ({
      ...p,
      opciones: [...p.opciones, nuevaOpcion.trim()],
    }));
    setNuevaOpcion("");
  };

  const removeOpcion = (index) => {
    setForm((p) => ({
      ...p,
      opciones: p.opciones.filter((_, i) => i !== index),
    }));
  };

  /* ---------------- SAVE ---------------- */
  const save = async () => {
    setIsLoading(true);
    try {
      const payload = {
        grupo, // 🔑 CLAVE: ESTO FALTABA
        nombre: form.nombre,
        key: form.key,
        tipo: form.tipo,
        requerido: form.requerido,
        filtrable: form.filtrable,
        opciones: form.tipo === "select" ? form.opciones : [],
      };

      if (data?._id) {
        await axios.put(
          `${API}/categoria-caracteristicas/${data._id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } },
        );
      } else {
        await axios.post(`${API}/categoria-caracteristicas`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      toast.success("Característica guardada");
      onSaved();
    } catch (error) {
      setIsLoading(false);
      toast.error(
        error.response?.data?.message || "Error guardando característica",
      );
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
        {/* HEADER */}
        <div className="p-6 pb-2 border-b">
          <h3 className="text-lg font-semibold">
            {data ? "Editar" : "Nueva"} característica
          </h3>
        </div>

        {/* BODY SCROLL */}
        <div className="p-6 space-y-4 overflow-y-auto">
          <InputField
            label="Nombre"
            name="nombre"
            value={form.nombre}
            onChange={handleChange}
            placeholder="Característica"
            required
          />

          <InputField
            label="Key (única)"
            name="key"
            value={form.key}
            onChange={handleChange}
            disabled={!!data}
            placeholder="ej: voltaje"
            required
          />

          <SelectField
            label="Tipo"
            name="tipo"
            value={form.tipo}
            onChange={handleChange}
            options={TIPOS}
          />

          {/* OPCIONES SELECT */}
          {form.tipo === "select" && (
            <div className="space-y-2">
              {/* INPUT + ADD */}
              <div className="flex gap-2">
                <InputField
                  placeholder="Nueva opción"
                  value={nuevaOpcion}
                  onChange={(e) => setNuevaOpcion(e.target.value)}
                />
                <Button type="button" onClick={addOpcion}>
                  +
                </Button>
              </div>

              {/* 🔍 BUSCADOR */}
              <InputField
                placeholder="Buscar opción..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />

              {/* LISTADO CON SCROLL */}
              <ul className="space-y-1 max-h-40 overflow-y-auto border rounded-lg p-2">
                {form.opciones
                  .filter((op) =>
                    op.toLowerCase().includes(busqueda.toLowerCase()),
                  )
                  .map((op, i) => (
                    <li
                      key={i}
                      className="flex justify-between items-center text-sm bg-gray-100 px-2 py-1 rounded"
                    >
                      {op}
                      <button
                        type="button"
                        onClick={() => removeOpcion(i)}
                        className="text-red-500"
                      >
                        ✕
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          )}

          {/* CHECKS */}
          <div className="flex flex-wrap gap-4">
            <label className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={form.requerido}
                onChange={(e) =>
                  setForm((p) => ({ ...p, requerido: e.target.checked }))
                }
              />
              Requerido
            </label>

            <label className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={form.filtrable}
                onChange={(e) =>
                  setForm((p) => ({ ...p, filtrable: e.target.checked }))
                }
              />
              Filtrable
            </label>
          </div>
        </div>

        {/* FOOTER FIJO */}
        <div className="p-6 pt-4 border-t flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={save}>
            {isLoading ? "Guardando..." : "Guardar"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CaracteristicaForm;
